import React from "react";
import styles from "./MarginExamples.module.scss";

export function MarginExamples() {
  const examples = [
    { name: "3XS", variable: "--spacing-3xs", value: "1px", pixels: "1" },
    { name: "2XS", variable: "--spacing-2xs", value: "2px", pixels: "2" },
    { name: "XS", variable: "--spacing-xs", value: "4px", pixels: "4" },
    { name: "S", variable: "--spacing-s", value: "8px", pixels: "8" },
    { name: "M", variable: "--spacing-m", value: "12px", pixels: "12" },
    { name: "L", variable: "--spacing-l", value: "16px", pixels: "16" },
    { name: "XL", variable: "--spacing-xl", value: "24px", pixels: "24" },
    { name: "2XL", variable: "--spacing-2xl", value: "32px", pixels: "32" },
    { name: "3XL", variable: "--spacing-3xl", value: "40px", pixels: "40" },
    { name: "4XL", variable: "--spacing-4xl", value: "48px", pixels: "48" },
    { name: "5XL", variable: "--spacing-5xl", value: "56px", pixels: "56" },
    { name: "6XL", variable: "--spacing-6xl", value: "64px", pixels: "64" },
    { name: "7XL", variable: "--spacing-7xl", value: "72px", pixels: "72" },
    { name: "8XL", variable: "--spacing-8xl", value: "80px", pixels: "80" },
    { name: "9XL", variable: "--spacing-9xl", value: "88px", pixels: "88" },
    { name: "10XL", variable: "--spacing-10xl", value: "96px", pixels: "96" },
    { name: "11XL", variable: "--spacing-11xl", value: "104px", pixels: "104" },
    { name: "12XL", variable: "--spacing-12xl", value: "112px", pixels: "112" },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.titleContainer}>
          <div className={styles.title}>Margin Examples</div>
        </div>

        <section className={styles.section}>
          <div className={styles.sectionTitle}>Margin Scale</div>
          {examples.map((example) => (
            <div key={example.name} className={styles.example}>
              <div className={styles.exampleTitle}>Margin {example.name}</div>
              <div className={styles.exampleValue}>
                {example.variable} ({example.value})
              </div>
              <div className={styles.boxWrapper}>
                <div className={styles.box} style={{ margin: example.value }} />
              </div>
            </div>
          ))}
        </section>
      </div>
    </div>
  );
}
